module.exports = __webpack_public_path__ + "assets/img/solar-capacity.a3c52b97.svg";